module.exports = __webpack_public_path__ + "static/media/forzaapp.04708279.png";